import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Form, FormFeedback, FormGroup, Input, Label, PopoverBody, Row, UncontrolledPopover } from 'reactstrap';
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { useFormik } from 'formik';
import * as Yup from "yup";
import axios from "axios";
import { getDomain, ValidateNumber } from '../../utils/check-value';
import SingleUploadfile from '../../common/single-uploadfile';
import MultipleUploadfile from '../../common/multiple-uploadfile';
import ConfigData from '../../../config.json';
import { IconAlertError, IconAlertReturn } from '../../../components/common/popup-alert';
import { ConvertStringDate } from '../../utils/convert-date';
import { setStringFileNameToArray } from '../../utils/format-value';

const RequestFormPoa = ({ dataFormPoa, dataFormRequest, onSaveDraft, onSave, onCancelRequest}) => {
    const history = useHistory();
    const [formTemp, setFormTemp] = useState({});
    const [filePurposePoaDoc, setFilePurposePoaDoc] = useState([]);
    const [fileAttorneyDoc, setFileAttorneyDoc] = useState([]);
    const [fileDetailPoaDoc, setFileDetailPoaDoc] = useState([]);
    const [fileFormOtherPoaDoc, setFileFormOtherPoaDoc] = useState([]);
    const [selectBU, setSelectBU] = useState(null);
    const [isBuOther, setIsBuOther] = useState(false);
    const [durationPoaType, setDurationPoaType] = useState("");
    const [companyAffidavitType, setCompanyAffidavitType] = useState("");
    const [reqIdcardHouseregisType, setReqIdcardHouseregisType] = useState("");
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);
    const [formIsDisabled, setFormIsDisabled] = useState(false);
    const [isSelectBuDisable, setIsSelectBuDisable] = useState(false);
    const [isBuOtherDisable, setIsBuOtherDisable] = useState(true);
    const [showCommentApprover, setShowCommentApprover] = useState(false);
    const [ddlBU, setDdlBU] = useState([]);
    const [dataUser, setDataUser] = useState([]);
    const [dataDetail, setDataDetail] = useState({});
    const [emailLegalAdmin , setEmailLegalAdmin] = useState([]);
    const [emailLegalAuthorized , setEmailLegalAuthorized] = useState([]);

    const userEmail = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
    const englishEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const thaiTimezoneOffset = 7 * 60; 
    const offsetInMilliseconds = thaiTimezoneOffset * 60 * 1000;
    const thaiDateTime = new Date(new Date().getTime() + offsetInMilliseconds);
    const newDateTime = thaiDateTime.toISOString().slice(0, 19).replace("T", " ");

    useEffect(() => {
        LoadDataBusinessUnit();
        LoadProfileUser(userEmail);
        LoadLegalAdmin(5);
    }, []);

    useEffect(() => {
        if(dataFormPoa?.id > 0){
            let updatedDataFormPoa = {...dataFormPoa};
            if (updatedDataFormPoa.request_no === "draft" && updatedDataFormPoa.id_business_unit === "-1") {
                updatedDataFormPoa.id_business_unit = "";
            }

            setDataDetail(updatedDataFormPoa);
            setFilePurposePoaDoc(updatedDataFormPoa.purpose_poa_doc ? setStringFileNameToArray(updatedDataFormPoa.purpose_poa_doc) : []);
            setFileAttorneyDoc(updatedDataFormPoa.attorney_doc ? setStringFileNameToArray(updatedDataFormPoa.attorney_doc) : []);
            setFileDetailPoaDoc(updatedDataFormPoa.detail_poa_doc ? setStringFileNameToArray(updatedDataFormPoa.detail_poa_doc) : []);
            setFileFormOtherPoaDoc(updatedDataFormPoa.form_other_poa_doc ? setStringFileNameToArray(updatedDataFormPoa.form_other_poa_doc) : []);
            LoadFormTempById(dataFormRequest.id_form_temp);
        }
    }, [dataFormPoa, dataFormRequest]);

    useEffect(() => {
        if(dataFormPoa?.id > 0){
            // 1. set group requestor can edit when id workflow = 4 or draft or user groupId2 when user can approve request.
            // 2,3. set group approver can edit when id workflow = 1,2
            if( ((dataFormRequest.id_workflow_status === 4 && userEmail === dataFormRequest.request_by) || dataFormRequest.id_workflow_status === 0)
                || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
                || (dataFormRequest.id_workflow_status === 1 && userEmail === dataFormRequest.approve_request_by) 
                || (dataFormRequest.id_workflow_status === 2 && userEmail === dataFormRequest.approve_request_by)
            ){
                setFormIsDisabled(false);
            } else if( dataFormRequest.id_workflow_status > 4 ){
                setFormIsDisabled(false);
                setIsSelectBuDisable(false);
                setIsBuOtherDisable(false);
            } else {
                setFormIsDisabled(true);
                setIsSelectBuDisable((dataFormPoa?.request_no === "draft" && dataFormPoa?.id_business_unit === "-1") ? false : true);
                setIsBuOtherDisable((dataFormPoa?.request_no === "draft" && dataFormPoa?.id_business_unit === "-1") ? true : false);
            }
            setSelectBU(ddlBU.find(x => x.value === dataFormPoa?.id_business_unit.toString()) ?? "");
            setDurationPoaType((dataFormPoa?.duration_poa_type !== "") ? dataFormPoa?.duration_poa_type : "");
            setCompanyAffidavitType((dataFormPoa?.company_affidavit_type !== "") ? dataFormPoa?.company_affidavit_type : "");
            setReqIdcardHouseregisType((dataFormPoa?.req_idcard_houseregis_type !== "") ? dataFormPoa?.req_idcard_houseregis_type : "");
        }
    }, [ddlBU, dataFormPoa]);

    const checkShowInputUserCoordinator = (
        (getDomain(userEmail) === "rabbitholdings.co.th" || dataUser.business_unit?.toLowerCase() === "rabbit holdings public company limited") 
        && (dataFormPoa?.id === 0 || dataFormRequest.request_no === "draft")
    );

    const checkUserIsApproverShowReturnBtn = (
        dataUser.email === dataFormRequest.approve_request_by && dataFormRequest.id_workflow_status !== 4
    );

    const checkUserCreateTicketAndApproveIsSame = ( 
        dataFormRequest.request_by !== dataFormRequest.approve_request_by
    );

    const changeButtonIsStateRequestorOrApprover = (
        (dataFormRequest.id_workflow_status !== 1 && dataFormRequest.id_workflow_status !== 2 && dataUser.email === dataFormRequest.request_by) 
        || (dataFormRequest.id_workflow_status !== 4 && dataUser.email === dataFormRequest.approve_request_by) 
        || (dataFormPoa?.id === 0)
    );

    const checkAuthorizedSubmitOrApprove = (
        (dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by) 
        || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
        || dataFormRequest.id_workflow_status === 4
    );

    const checkAuthorizedReturn = (
        (dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by) 
        || (dataUser.id_user_group === 2) 
        || (dataFormRequest.id_workflow_status === 4)
    );

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_request: dataDetail.id_request || 0,
            id_request_type: dataDetail.id_request_type || 0,
            id_sub_request_type: dataDetail.id_sub_request_type || 0,
            id_sub_division_request_type: dataDetail.id_sub_division_request_type || 0,
            purpose_poa: dataDetail.purpose_poa || "",
            purpose_poa_doc: dataDetail.purpose_poa_doc || "",
            date_poa: dataDetail.date_poa || "",
            date_poa_reason: dataDetail.date_poa_reason || "",
            id_business_unit: dataDetail.id_business_unit || "",
            business_unit_other: dataDetail.business_unit_other || "",
            grantor: dataDetail.grantor || "",
            attorney: dataDetail.attorney || "",
            attorney_doc: dataDetail.attorney_doc || "",
            attorney_number_condition: dataDetail.attorney_number_condition || "",
            detail_poa: dataDetail.detail_poa || "",
            detail_poa_doc: dataDetail.detail_poa_doc || "",
            duration_poa_type: dataDetail.duration_poa_type || "",
            duration_poa_start_date: dataDetail.duration_poa_start_date || "",
            duration_poa_end_date: dataDetail.duration_poa_end_date || "",
            duration_poa_reason: dataDetail.duration_poa_reason || "",
            witness: dataDetail.witness || "",
            form_other_poa: dataDetail.form_other_poa || "",
            form_other_poa_doc: dataDetail.form_other_poa_doc || "",
            other_support_doc: dataDetail.other_support_doc || "",
            company_affidavit_type: dataDetail.company_affidavit_type || "",
            company_affidavit_age: dataDetail.company_affidavit_age || "",
            company_affidavit_reason: dataDetail.company_affidavit_reason || "",
            req_idcard_houseregis_type: dataDetail.req_idcard_houseregis_type || "",
            req_idcard_houseregis_amount: dataDetail.req_idcard_houseregis_amount || "",
            req_idcard_houseregis_reason: dataDetail.req_idcard_houseregis_reason || "",
            other_info: dataDetail.other_info || "",
            require_handled_by: dataFormRequest?.require_handled_by ||dataDetail.require_handled_by || "",
            approve_request_by: dataFormRequest?.approve_request_by || dataDetail.approve_request_by || "",
            approver_comment: dataFormRequest?.approver_comment || dataDetail.approver_comment || "",
            create_request_by: dataFormRequest?.create_request_by || dataDetail.create_request_by || "",
            check_request_no: dataFormRequest?.request_no || "",
            check_user_email: dataFormRequest?.create_request_by || dataDetail?.create_request_by || userEmail,
            request_no: dataFormRequest?.request_no || "",
            id_workflow_status: dataFormRequest?.id_workflow_status || 0,
        },
        validationSchema: Yup.object({
            purpose_poa: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            purpose_poa_doc: Yup.string().required("กรุณาแนบไฟล์/Please attachment file"),
            date_poa: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            id_business_unit: Yup.string().when("isDisabled", {
                is: (isDisabled) => !isDisabled,
                then: Yup.string().required("กรุณาเลือก/Please select"),
                otherwise: Yup.string().notRequired(),
            }),
            business_unit_other: Yup.string().when(["id_business_unit", "isDisabled"], {
                is: (id_business_unit, isDisabled) => !isDisabled && id_business_unit === "-1",
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            attorney: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            attorney_doc: Yup.string().required("กรุณาแนบไฟล์/Please attachment file"),
            attorney_number_condition: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            detail_poa: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            duration_poa_start_date: Yup.string().when(["duration_poa_type"], {
                is: (duration_poa_type) => duration_poa_type === "2",
                then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            duration_poa_end_date: Yup.string().when(["duration_poa_type"], {
                is: (duration_poa_type) => duration_poa_type === "2",
                then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            duration_poa_reason: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            witness: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            form_other_poa: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            company_affidavit_age: Yup.string().when(["company_affidavit_type", "isDisabled"], {
                is: (company_affidavit_type, isDisabled) => !isDisabled && company_affidavit_type === "1",
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out").matches(/^[0-9,.]+$/, "กรุณากรอกเฉพาะตัวเลข\nPlease enter only numbers"),
                otherwise: Yup.string().notRequired(),
            }),
            company_affidavit_reason: Yup.string().when(["company_affidavit_type", "isDisabled"], {
                is: (company_affidavit_type, isDisabled) => !isDisabled && company_affidavit_type === "2",
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            req_idcard_houseregis_amount: Yup.string().required("กรุณากรอกข้อมูล/Please fill out").matches(/^[0-9,.]+$/, "กรุณากรอกเฉพาะตัวเลข\nPlease enter only numbers"),
            req_idcard_houseregis_reason: Yup.string().when(["req_idcard_houseregis_amount", "isDisabled"], {
                is: (req_idcard_houseregis_amount, isDisabled) => !isDisabled && req_idcard_houseregis_amount > 1,
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            require_handled_by: Yup.string().email("กรุณาระบุอีเมลนักกฎหมาย/Please provide the lawyer's email address").matches(englishEmailRegex, "Email must be a valid English email address"),
            approve_request_by: Yup.string().when("check_request_no", {
                is: (check_request_no) => check_request_no === undefined || check_request_no === "draft",
                then: Yup.string().required("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address")
                .email("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address").matches(englishEmailRegex, "Email must be a valid English email address")
                .test('is-not-current-user', 'ไม่สามารถใช้อีเมลของผู้ใช้งานปัจจุบัน/You cannot use your own email', function(value) {
                    return value?.toLowerCase() !== userEmail; 
                }),
                otherwise: Yup.string().required("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address")
                .email("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address").matches(englishEmailRegex, "Email must be a valid English email address"),
            }),
            create_request_by: Yup.string().when("check_user_email", {
                is: (check_user_email) => getDomain(check_user_email) === "rabbitholdings.co.th" || dataUser.business_unit?.toLowerCase() === "rabbit holdings public company limited",
                then: Yup.string().required("กรุณาระบุอีเมลผู้ประสานงาน/Please provide the coordinator's email address")
                .email("กรุณาระบุอีเมลผู้ประสานงาน/Please provide the coordinator's email address")
                .matches(englishEmailRegex, "Email must be a valid English email address"),
                otherwise: Yup.string().nullable(),
            }),
        }),
        onSubmit: (values) => {
            values.file_purpose_poa_doc = filePurposePoaDoc;
            values.file_attorney_doc = fileAttorneyDoc;
            values.file_detail_poa_doc = fileDetailPoaDoc;
            values.file_form_other_poa_doc = fileFormOtherPoaDoc;
            values.approve_request_by = values.approve_request_by?.toLowerCase();
            values.require_handled_by = values.require_handled_by?.toLowerCase();
            values.create_request_by = values.create_request_by?.toLowerCase();
            values.legal_authorized = emailLegalAuthorized;
            values.legal_admin = emailLegalAdmin;
            values.id_business_unit = (values.id_business_unit !== "") ? parseInt(values.id_business_unit) : 0;
            values.date_poa = ConvertStringDate(values.date_poa, "yyyy-MM-dd", "yyyy-MM-dd", "-");
            values.date_poa = (values.date_poa !== "") ? values.date_poa : null;
            values.duration_poa_start_date = ConvertStringDate(values.duration_poa_start_date, "yyyy-MM-dd", "yyyy-MM-dd", "-");
            values.duration_poa_start_date = (values.duration_poa_start_date !== "") ? values.duration_poa_start_date : null;
            values.duration_poa_end_date = ConvertStringDate(values.duration_poa_end_date, "yyyy-MM-dd", "yyyy-MM-dd", "-");
            values.duration_poa_end_date = (values.duration_poa_end_date !== "") ? values.duration_poa_end_date : null;
            onSave(values);
        }
    });

    const validationDraft = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_request: dataDetail.id_request || 0,
            id_request_type: dataDetail.id_request_type || 0,
            id_sub_request_type: dataDetail.id_sub_request_type || 0,
            id_sub_division_request_type: dataDetail.id_sub_division_request_type || 0,
            purpose_poa: dataDetail.purpose_poa || "",
            purpose_poa_doc: dataDetail.purpose_poa_doc || "",
            date_poa: dataDetail.date_poa || "",
            date_poa_reason: dataDetail.date_poa_reason || "",
            id_business_unit: dataDetail.id_business_unit || "",
            business_unit_other: dataDetail.business_unit_other || "",
            grantor: dataDetail.grantor || "",
            attorney: dataDetail.attorney || "",
            attorney_doc: dataDetail.attorney_doc || "",
            attorney_number_condition: dataDetail.attorney_number_condition || "",
            detail_poa: dataDetail.detail_poa || "",
            detail_poa_doc: dataDetail.detail_poa_doc || "",
            duration_poa_type: dataDetail.duration_poa_type || "",
            duration_poa_start_date: dataDetail.duration_poa_start_date || "",
            duration_poa_end_date: dataDetail.duration_poa_end_date || "",
            duration_poa_reason: dataDetail.duration_poa_reason || "",
            witness: dataDetail.witness || "",
            form_other_poa: dataDetail.form_other_poa || "",
            form_other_poa_doc: dataDetail.form_other_poa_doc || "",
            other_support_doc: dataDetail.other_support_doc || "",
            company_affidavit_type: dataDetail.company_affidavit_type || "",
            company_affidavit_age: dataDetail.company_affidavit_age || "",
            company_affidavit_reason: dataDetail.company_affidavit_reason || "",
            req_idcard_houseregis_type: dataDetail.req_idcard_houseregis_type || "",
            req_idcard_houseregis_amount: dataDetail.req_idcard_houseregis_amount || "",
            req_idcard_houseregis_reason: dataDetail.req_idcard_houseregis_reason || "",
            other_info: dataDetail.other_info || "",
            require_handled_by: dataFormRequest?.require_handled_by ||dataDetail.require_handled_by || "",
            approve_request_by: dataFormRequest?.approve_request_by || dataDetail.approve_request_by || "",
            approver_comment: dataFormRequest?.approver_comment || dataDetail.approver_comment || "",
            create_request_by: dataFormRequest?.create_request_by || dataDetail.create_request_by || "",
            check_request_no: dataFormRequest?.request_no || "",
            check_user_email: dataFormRequest?.create_request_by || dataDetail?.create_request_by || userEmail,
            request_no: dataFormRequest?.request_no || "",
            id_workflow_status: dataFormRequest?.id_workflow_status || 0,
        },
        onSubmit: (values) => {
            values.request_no = dataFormRequest.request_no; // check request_no
            values.file_purpose_poa_doc = filePurposePoaDoc;
            values.file_attorney_doc = fileAttorneyDoc;
            values.file_detail_poa_doc = fileDetailPoaDoc;
            values.file_form_other_poa_doc = fileFormOtherPoaDoc;
            values.approve_request_by = values.approve_request_by?.toLowerCase();
            values.require_handled_by = values.require_handled_by?.toLowerCase();
            values.create_request_by = values.create_request_by?.toLowerCase();
            values.legal_authorized = emailLegalAuthorized;
            values.legal_admin = emailLegalAdmin;
            values.id_business_unit = (values.id_business_unit !== "") ? parseInt(values.id_business_unit) : 0;
            values.date_poa = ConvertStringDate(values.date_poa, "yyyy-MM-dd", "yyyy-MM-dd", "-");
            values.date_poa = (values.date_poa !== "") ? values.date_poa : null;
            values.duration_poa_start_date = ConvertStringDate(values.duration_poa_start_date, "yyyy-MM-dd", "yyyy-MM-dd", "-");
            values.duration_poa_start_date = (values.duration_poa_start_date !== "") ? values.duration_poa_start_date : null;
            values.duration_poa_end_date = ConvertStringDate(values.duration_poa_end_date, "yyyy-MM-dd", "yyyy-MM-dd", "-");
            values.duration_poa_end_date = (values.duration_poa_end_date !== "") ? values.duration_poa_end_date : null;
            onSaveDraft(values);
        }
    });

    const validationReturn = useFormik({
        enableReinitialize: true,
        initialValues: {
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
        },
        validationSchema: Yup.object({
            approver_comment: Yup.string().trim().required("กรุณาระบุความเห็นเพิ่มเติม"),
        }),
        onSubmit: (values) => {
            // console.log(values);
        }
    });

    const GetUrlBack = () => {
        const urlBack = (dataFormRequest.table_name !== "" && dataFormRequest.table_name !== null && dataFormRequest.table_name !== undefined) ? "/request-form/" + btoa(dataFormRequest.table_name) : "/all-type-request";
        return urlBack;
    };

    const OnChangeIsBuOther = (e) => {
        setIsBuOther(e.target.checked);
        setIsSaveEnabled(true);
        if(e.target.checked === true){
            setSelectBU(null);
            setIsSelectBuDisable(true);
            setIsBuOtherDisable(false);
            validation.setFieldValue("id_business_unit", "-1");
            validation.setFieldValue("business_unit_other", "");
            validation.setFieldError("id_business_unit", null);
            validation.setFieldError("business_unit_other", null);
            validation.setFieldTouched("id_business_unit", false);
            validation.setFieldTouched("business_unit_other", false);
        }else{
            setIsSelectBuDisable(false);
            setIsBuOtherDisable(true);
            validation.setFieldValue("id_business_unit", "");
            validation.setFieldValue("business_unit_other", "");
            validation.setFieldError("id_business_unit", null);
            validation.setFieldError("business_unit_other", null);
            validation.setFieldTouched("id_business_unit", false);
            validation.setFieldTouched("business_unit_other", false);
        }
    };

    const OnSetFilePurposeDoc = (files) => {
        const fileNames = files.map(file => file.name).join(",");
        setFilePurposePoaDoc(files);
        validation.handleChange('purpose_poa_doc')(fileNames);
        validationDraft.handleChange('purpose_poa_doc')(fileNames);
        setIsSaveEnabled(true);
    };

    const OnSetFileAttorneyDoc = (files) => {
        const fileName = (files.length > 0) ? files[0].name : "";
        setFileAttorneyDoc(files);
        validation.handleChange('attorney_doc')(fileName);
        validationDraft.handleChange('attorney_doc')(fileName);
        setIsSaveEnabled(true);
    };

    const OnSetFileDetailPoaDoc = (files) => {
        const fileName = (files.length > 0) ? files[0].name : "";
        setFileDetailPoaDoc(files);
        validation.handleChange('detail_poa_doc')(fileName);
        validationDraft.handleChange('detail_poa_doc')(fileName);
        setIsSaveEnabled(true);
    };

    const OnSetFileFormOtherPoaDoc = (files) => {
        const fileName = (files.length > 0) ? files[0].name : "";
        setFileFormOtherPoaDoc(files);
        validation.handleChange('form_other_poa_doc')(fileName);
        validationDraft.handleChange('form_other_poa_doc')(fileName);
        setIsSaveEnabled(true);
    };

    const onClickCheckReturn = async () => {
        setShowCommentApprover(true);
        
        // ทำการ submit form เพื่อ trigger การ validate
        await validationReturn.submitForm();
        // ตรวจสอบค่าของ showCommentApprover
        if (showCommentApprover) {
            // ตรวจสอบว่ามีข้อผิดพลาดหรือไม่
            const errors = validationReturn.errors;
            // console.log(errors);
            
            if (Object.keys(errors).length === 0) {
                // ตรวจสอบสิทธิ์การอนุมัติ
                if (checkAuthorizedReturn) {
                    onReturn(dataFormRequest, validation.values);
                } else {
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "You Are not authorized to action this.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            } else {
                // ถ้ามีข้อผิดพลาด แสดงข้อความเตือน
                Swal.fire({
                    iconHtml: IconAlertError,
                    title: "กรุณากรอกข้อมูลความเห็นของผู้อนุมัติ",
                    showConfirmButton: false,
                    showCloseButton: true,
                });
            }
        }
    };

    const onClickCheckSaveDraft = () => {
        if((dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by ) || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
            || dataFormRequest.id_workflow_status === 4 
            || dataFormRequest.id_workflow_status === 0
        ){
            validationDraft.submitForm();
        } else if(dataFormPoa.id_request === "" || dataFormPoa.id_request === 0){
            validationDraft.submitForm();
        } else {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "You Are not authorized to action this.",
                showConfirmButton: false,
                showCloseButton: true,
            });
        }
    };

    const onClickCheckSubmit = async () => {
        // ทำการ validate ฟอร์มทั้งหมด
        const errors = await validation.validateForm();
    
        // ตรวจสอบว่ามี error หรือไม่
        if (Object.keys(errors).length > 0) {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                showConfirmButton: false,
                showCloseButton: true,
            });
            // return; // หยุดการทำงานถ้ามี error
        }
    
        // ถ้าไม่มี error ให้ทำการ submit form
        if (!dataFormRequest.id_workflow_status) {
            validation.submitForm();
        } else if ( checkAuthorizedSubmitOrApprove ) {
            validation.submitForm();
        } else {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "You Are not authorized to action this.",
                showConfirmButton: false,
                showCloseButton: true,
            });
        }
    };

    const LoadProfileUser = (email) => {
        let url = ConfigData.API_URL + "user/search?status=1&email=" + email;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setDataUser(respData.data[0]);
                LoadLegalAuthorized(respData.data[0].id_business_unit);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadFormTempById = (idFormTemp) =>{
        let url = ConfigData.API_URL + "form-temp/" + idFormTemp;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setFormTemp(respData.data[0]);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataBusinessUnit = () => {
        let url = ConfigData.API_URL + "business-unit/search?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_en,
                        value: e.id.toString()
                    };
                });
                setDdlBU(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadLegalAdmin = (groupId) => {
        let url = ConfigData.API_URL + "user/?status=1&id_user_group=" + groupId;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
            responseType: "json",
        })
        .then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                setEmailLegalAdmin(respData.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const LoadLegalAuthorized = (idBusinessUnit) => {
        let url = ConfigData.API_URL + "map-user-assign/search?status=1&id_business_unit=" + idBusinessUnit;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setEmailLegalAuthorized(respData.data);
            } else {
                setEmailLegalAuthorized("");
            }
        })
        .catch(error => {
            console.log(error);
        });
    };

    const onReturn = (dataRequest, dataFormPoa) => {
        // setIsShowModal(!isShowModal);
        Swal.fire({
            icon: 'info',
            title: 'Loading...',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });
  
        let isSaveSucess = true;
        (async () => {
            try{
                let dataReturn = await ApprovalReturn(dataRequest.id);
                isSaveSucess = (dataReturn.is_sucess === true && isSaveSucess === true) ? true : false;
                
                const dataRequestWorkFlows = {
                    "id_request": dataRequest.id,
                    "id_workflow_status" : 4,
                    "do_by" : userEmail,
                    "send_to" : dataRequest.request_by,
                    "cc_to" : null,
                    "comment" : dataFormPoa.approver_comment,
                    "document" : null,
                    "consent" : null,
                    "do_date" : newDateTime,
                };
                let dataRequestWorkFlow = await AddRequestWorkFlow(dataRequestWorkFlows);
                isSaveSucess = (dataRequestWorkFlow.is_sucess === true && isSaveSucess === true) ? true : false;

                if(isSaveSucess === true){
                    let isSendMail = await SendMailReturn(dataRequestWorkFlow.data[0]);
                    if( isSendMail === true ){
                        Swal.close(); // Close loading spinner
                        Swal.fire({
                            iconHtml: IconAlertReturn,
                            title: "Return to user who request.",
                            showConfirmButton: false,
                            showCloseButton: true,
                            // showConfirmButton: false,
                        }).then(() => {
                            // props.nextStep();
                            history.push(GetUrlBack());
                        });
                    }else{
                        Swal.close(); // Close loading spinner
                        Swal.fire({
                            iconHtml: IconAlertError,
                            title: "Failed to send email to user who request.",
                            showConfirmButton: false,
                            showCloseButton: true,
                        });
                    }
                }else{
                    Swal.close(); // Close loading spinner
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "Failed to save data.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            } catch(error){
                console.log(error);
            }
        })();
    };

    const ApprovalReturn = async (id) => {
        let url = ConfigData.API_URL + "request/approval-return/" + id;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url,{}, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // setDataIdRequest(respData.data)
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const AddRequestWorkFlow = async (dataRequestWorkFlows) => {
        let url = ConfigData.API_URL + "request-workflow/";
        let data = dataRequestWorkFlows;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.post(url, data, { headers: { 
                                'Authorization' : token,
                                'User': userId,
                            }, responseType: "json" }
                        );
            let respData = resp.data;
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const SendMailReturn = async (data) => {
        const url = ConfigData.API_URL + "email/send";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let arrTo = data.send_to.split(",");
        let dataReq = {
            "to": arrTo,
            "template_id": 2,
            "request_id": data.id_request,
        };
        try {
            const resp = await axios.post(url, dataReq, { headers: { 
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        } catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    return (
        <React.Fragment>
            <div id="form-request" className="mx-auto">
                <Form className="needs-validation"
                    onSubmit={(e) => {
                        e.preventDefault();
                        // validation.handleSubmit();
                        return false;
                    }}
                >
                    <div id="section-page-1-2">
                        <Row>
                            <Col md={12}>
                                <span className="span-title">
                                    ข้อมูลทั่วไป (Request General Information)
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup className="pt-3">
                                    <Label className="label-title">ประเภทคำขอ (Type of Request)</Label>
                                    <Input id="txtTypeOfRequest"
                                        type="text"
                                        name="typeOfRequest"
                                        value={dataFormRequest.name_en_request_type ? dataFormRequest.name_en_request_type || "" : formTemp.name_en_request_type || ""}
                                        disabled
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <div className="line-border"></div>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-3">
                        <Row>
                            <Col md={12} className="mb-3">
                                <span className="span-title">
                                    ข้อมูลเอกสาร (Request Form Information)
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">วัตถุประสงค์ที่ต้องการหนังสือมอบอำนาจ (Purpose of this Power of Attorney (POA)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prPurposePOA"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prPurposePOA" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการมอบอำนาจ เพื่อฝ่ายกฎหมาย ใช้พิจารณาการออกหนังสือมอบอำนาจให้
                                                <br />
                                                Please attach the document for which the power of attorney is required, so that the Legal Team can review and issue the power of attorney accordingly.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtPurposePOA"
                                        name="purpose_poa"
                                        placeholder="ต้องการนำไปใช้ดำเนินการเรื่อง"
                                        type="textarea"
                                        rows="5"
                                        className="from-control"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.purpose_poa || ""}
                                        invalid={ validation.touched.purpose_poa && validation.errors.purpose_poa ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                    { validation.touched.purpose_poa && validation.errors.purpose_poa ? ( 
                                        <FormFeedback type="invalid" style={{display: "block"}}>
                                            {validation.errors.purpose_poa}
                                        </FormFeedback> 
                                    ) : false }
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-4">
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title mb-3">
                                        โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการมอบอำนาจ เพื่อฝ่ายกฎหมายใช้พิจารณาออกหนังสือมอบอำนาจให้<span className="msg-require">*</span>
                                        <br/>
                                        Please attach the document for which the power of attorney is required, so that the Legal Team
                                        <br/>
                                        can review and issue the power of attorney accordingly.
                                    </Label>
                                    <MultipleUploadfile inputID="purposePoaDoc" folder={dataFormRequest.request_no} dataFile={filePurposePoaDoc} setDataFile={OnSetFilePurposeDoc} isDisable={formIsDisabled} />
                                    { validation.touched.purpose_poa_doc && validation.errors.purpose_poa_doc ? ( 
                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                            {validation.errors.purpose_poa_doc}
                                        </FormFeedback> 
                                    ) : false }
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-5">
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">วันทำหนังสือมอบอำนาจ(Date of Power of Attorney)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightForUse"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="PopoverRightForUse" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                ฝ่ายกฎหมายจะจัดทำหนังสือมอบอำนาจเป็นวันที่ปัจจุบัน หากuserประสงค์จะระบุเป็นวันที่เฉพาะเจาะจง โปรดแจ้งวันที่พร้อมระบุเหตุผลความจำเป็น
                                                <br />
                                                Legal Team will prepare the power of attorney with the current date. If the user wishes to specify a particular date, please provide the date along with the reason for this necessity.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtDatePoa"
                                        name="date_poa"
                                        type="date"
                                        className="form-control"
                                        value={validation.values.date_poa || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.date_poa && validation.errors.date_poa ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">ระบุเหตุผลที่ไม่สามารถลงวันที่เป็นปัจจุบันได้ (The reason for this necessity)</Label>
                                    <Input id="txtDatePoaReason"
                                        name="date_poa_reason"
                                        placeholder="ต้องการนำไปใช้ดำเนินการเรื่อง"
                                        type="textarea"
                                        rows="5"
                                        className="from-control"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.date_poa_reason || ""}
                                        invalid={ validation.touched.date_poa_reason && validation.errors.date_poa_reason ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-6">
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label className="label-title">ทำหนังสือมอบอำนาจในนามของ (Company Name)<span className="msg-require">*</span></Label>
                                    <Select id="ddlIdBusinessUnit"
                                        name="id_business_unit"
                                        value={selectBU}
                                        className="txt-placeholder"
                                        placeholder={(isBuOther === false) ? "โปรดเลือก..." : ""}
                                        onChange={(selected) => {
                                            setSelectBU(selected);
                                            validation.handleChange("id_business_unit")((selected !== null) ? selected.value : "");
                                            validationDraft.handleChange("id_business_unit")((selected !== null) ? selected.value : "");
                                            setIsSaveEnabled(true);

                                        }}
                                        options={ddlBU}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_business_unit && validation.errors.id_business_unit ? true : false }
                                        isDisabled={isSelectBuDisable}
                                    />
                                    { validation.touched.id_business_unit && validation.errors.id_business_unit ? ( 
                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                            {validation.errors.id_business_unit}
                                        </FormFeedback> 
                                    ) : false }
                                </FormGroup>
                            </Col>
                            <Col md={5}>
                                <FormGroup>
                                    <Input id="cbIsBuOther"
                                        type="checkbox"
                                        name="is_bu_other"
                                        checked={isBuOther}
                                        onChange={OnChangeIsBuOther}
                                        disabled={formIsDisabled}
                                    />
                                    <Label className="label-title" for="cbIsBuOther">อื่นๆ (Others)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prBusinessUnitOther"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prBusinessUnitOther" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดระบุว่าจะทำหนังสือมอบอำนาจในนามของ บริษัทในเครือรายใดหากuserต้องการระบุชื่อบริษัทที่ไม่มีในรายชื่อบริษัท โปรดเลือก Others และกรอกชื่อบริษัทดังกล่าว
                                                <br />
                                                Please indicate the company or affiliate name who is the party. If the party is not listed here, please select 'Others' and provide such company's name.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtBusinessUnitOther"
                                        name="business_unit_other"
                                        type="text"
                                        placeholder={(isBuOther === true) ? "กรอกชื่อบริษัท" : ""}
                                        className="txt-placeholder"
                                        value={validation.values.business_unit_other || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.business_unit_other && validation.errors.business_unit_other ? true : false }
                                        disabled={formIsDisabled || isBuOtherDisable}
                                    />
                                    {validation.touched.business_unit_other && validation.errors.business_unit_other ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.business_unit_other}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-7">
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label className="label-title">ชื่อผู้มอบอำนาจ (Name of the Grantor)</Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prGrantor"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prGrantor" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                ฝ่ายกฎหมายจะจัดทำเป็นชื่อกรรมการท่านหลัก และท่านนั้นอยู่ในประเทศไทย ณ วันที่ทำหนังสือมอบ อำนาจ หาก user ประสงค์จะระบุผู้มอบอำนาจเป็น การเฉพาะเจาะจง โปรดระบุชื่อผู้มอบอำนาจ
                                                <br />
                                                Legal Team will specify the name of key director, who is in Thailand on the date of the power of attorney issuance, as the grantor. If the user wishes to specify a particular grantor, please provide the name of the grantor.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtGrantor"
                                        name="grantor"
                                        type="text"
                                        placeholder="กรอก"
                                        className="txt-placeholder"
                                        value={validation.values.grantor || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.grantor && validation.errors.grantor ? true : false }
                                        disabled={formIsDisabled}
                                    />    
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">ชื่อผู้รับมอบอำนาจ (Name of the Attorney)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prAttorney"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prAttorney" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดระบุคำนำหน้า ชื่อ และนามสกุลของผู้รับมอบอำนาจให้ครบทุกท่าน และโปรดแนบไฟล์สำเนา บัตรประชาชนของผู้รับมอบอำนาจทุกท่าน
                                                <br />
                                                Please specify the title, first name, and last name of each attorney in full, and attach a copy of the ID card for each attorney.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtAttorney"
                                        name="attorney"
                                        type="textarea"
                                        rows="4"
                                        placeholder="กรอก"
                                        className="txt-placeholder"
                                        value={validation.values.attorney || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.attorney && validation.errors.attorney ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                    {validation.touched.attorney && validation.errors.attorney ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.attorney}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-8">
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title mb-3">
                                        โปรดแนบไฟล์สำเนาบัตรประชาชนของผู้รับมอบอำนาจทุกท่าน<span className="msg-require">*</span>
                                        <br/>
                                        Please specify the title, first name, and last name of each attorney in full, and attach a copy of the
                                        <br/>
                                        ID card for each attorney.
                                    </Label>
                                    <SingleUploadfile inputID="attornety" folder={dataFormRequest.request_no} dataFile={fileAttorneyDoc} setDataFile={OnSetFileAttorneyDoc} isDisable={formIsDisabled} />
                                    { validation.touched.attorney_doc && validation.errors.attorney_doc ? ( 
                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                            {validation.errors.attorney_doc}
                                        </FormFeedback> 
                                    ) : false }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">จำนวนคนและเงื่อนไขการดำเนินการของผู้รับมอบอำนาจ (Number and conditions of Attorney)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prAttorneyNumberCondition"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prAttorneyNumberCondition" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดระบุรายละเอียดจำนวนคนและเงื่อนไขการดำเนินการของผู้รับมอบอำนาจ เช่น ก เป็นผู้รับมอบอำนาจกระทำการคนเดียว ,ก หรือ ข คนใดคนหนึ่งเป็นผู้รับมอบอำนาจกระทำการ ,ก และ ข เป็นผู้รับมอบอำนาจกระทำการร่วมกัน
                                                <br />
                                                Please specify the details of the attorney's authority, such as: A is authorized to act alone,A or B, any one of them, is authorized to act, A and B are authorized to act jointly.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtDetailPoa"
                                        name="attorney_number_condition"
                                        type="textarea"
                                        rows="5"
                                        placeholder="ต้องการนำไปใช้ดำเนินการเรื่อง"
                                        className="txt-placeholder"
                                        value={validation.values.attorney_number_condition || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.attorney_number_condition && validation.errors.attorney_number_condition ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                    {validation.touched.attorney_number_condition && validation.errors.attorney_number_condition ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.attorney_number_condition}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-9">
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">มอบอำนาจให้ดำเนินการใดบ้าง (Details)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prDetailPoa"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prDetailPoa" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดระบุว่าต้องการมอบอำนาจ เพื่อดำเนินการอะไรบ้าง หากมีตัวอย่างหนังสือมอบ อำนาจที่เคยจัดทำแล้ว หรือมีแบบฟอร์มหนังสือ มอบอำนาจหรือเนื้อหาที่มอบอำนาจโดยกำหนด เฉพาะเจาะจงจากหน่วยงานราชการ โปรดแนบมาเป็นตัวอย่าง
                                                <br />
                                                Please specify the details of the actions you wish to authorize. If you have a previously issued power of attorney or a specific form or content required by a government agency, please attach it as an example.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtDetailPoa"
                                        name="detail_poa"
                                        type="textarea"
                                        rows="5"
                                        placeholder="ต้องการนำไปใช้ดำเนินการเรื่อง"
                                        className="txt-placeholder"
                                        value={validation.values.detail_poa || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.detail_poa && validation.errors.detail_poa ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                    {validation.touched.detail_poa && validation.errors.detail_poa ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.detail_poa}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title mb-3">
                                        หากมีตัวอย่างหนังสือมอบอำนาจที่เคยจัดทำแล้วหรือมีแบบฟอร์มหนังสือมอบอำนาจหรือเนื้อหาที่มอบอำนาจ
                                        <br/>
                                        โดยกำหนดเฉพาะเจาะจงจากหน่วยงานราชการ โปรดแนบมาเป็นตัวอย่าง
                                        <br/>
                                        Please specify the details of the actions you wish to authorize. If you have a previously issued 
                                        <br/>
                                        power of attorney or a specific form or content required by a government agency, please attach it 
                                        <br/>
                                        as an example.
                                    </Label>
                                    <SingleUploadfile inputID="detailPoaDoc" folder={dataFormRequest.request_no} dataFile={fileDetailPoaDoc} setDataFile={OnSetFileDetailPoaDoc} isDisable={formIsDisabled} />
                                    { validation.touched.detail_poa_doc && validation.errors.detail_poa_doc ?  ( 
                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                            {validation.errors.detail_poa_doc}
                                        </FormFeedback> 
                                    ) : false }
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-10">             
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">ระยะเวลาของหนังสือมอบอำนาจ (The duration of the POA)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-end" id="prDurationPoa"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prDurationPoa" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i>
                                                โปรดระบุว่า ใช้หนังสือมอบอำนาจเพียงครั้งเดียว หรือประสงค์ให้มีระยะเวลา
                                                <br />
                                                Please clarify whether this Power of Attorney is intended for one-time use or for a specified period.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <div className="form-check ms-5">
                                        <Input id="cbIsOneTime"
                                            name="duration_poa_type"
                                            className="form-check-input" 
                                            type="radio"
                                            checked={durationPoaType === "1"}
                                            onChange={() => {
                                                setDurationPoaType("1");
                                                validation.handleChange('duration_poa_type')("1");
                                                validationDraft.handleChange('duration_poa_type')("1");
                                                validation.handleChange('duration_poa_start_date')("");
                                                validationDraft.handleChange('duration_poa_start_date')("");
                                                validation.handleChange('duration_poa_end_date')("");
                                                validationDraft.handleChange('duration_poa_end_date')("");
                                                setIsSaveEnabled(true);
                                            }}
                                            disabled={formIsDisabled}
                                        />
                                        <Label className="form-check-label-2row" for="cbIsOneTime">
                                            ใช้หนังสือมอบอำนาจเพียงครั้งเดียว
                                            <br/>
                                            <span className="form-check-label-2row-detail">
                                                One time POA
                                            </span>
                                        </Label>
                                    </div>
                                    <div className="form-check ms-5 mt-3">
                                        <Input id="cbIsTimelimt"
                                            name="duration_poa_type"
                                            className="form-check-input" 
                                            type="radio"
                                            checked={durationPoaType === "2"}
                                            onChange={() => {
                                                setDurationPoaType("2");
                                                validation.handleChange('duration_poa_type')("2");
                                                validationDraft.handleChange('duration_poa_type')("2");
                                                setIsSaveEnabled(true);
                                            }}
                                            disabled={formIsDisabled}
                                        />
                                        <Label className="form-check-label-2row mb-0" for="cbIsTimelimt">
                                            ใช้แบบมีระยะเวลา (โปรดระบุวันที่เริ่มต้นและวันที่สิ้นสุด)
                                        </Label>
                                        <i className="mdi mdi-help-circle icon-hint-end" id="prIsTimelimt"></i>
                                        <div className="hstack flex-wrap gap-2">
                                            <UncontrolledPopover placement="right" target="prIsTimelimt" >
                                                <PopoverBody className="msg-show-hint">
                                                    <i className="mdi mdi-help-circle msg-icon-hint"></i>
                                                    โดยฝ่ายกฎหมายขอสงวนสิทธิ์พิจารณาปรับระยะเวลาให้ หากระบุระยะเวลามากกว่า 1 ปี
                                                </PopoverBody>
                                            </UncontrolledPopover>
                                        </div>
                                        <Label className="form-check-label-2row" for="cbIsTimelimt">
                                            <span className="form-check-label-2row-detail">
                                                POA with time limitation, please specify the start date and end date
                                            </span>
                                        </Label>
                                        
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-11">
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label className="label-title">วันที่เริ่มต้น (Start Date)<span className="msg-require">*</span></Label>
                                    <Input id="txtDurationPoaStartDate"
                                        name="duration_poa_start_date"
                                        type="date"
                                        className="form-control"
                                        value={validation.values.duration_poa_start_date || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.duration_poa_start_date && validation.errors.duration_poa_start_date ? true : false }
                                        disabled={formIsDisabled || durationPoaType !== "2"}
                                    />
                                    { validation.touched.duration_poa_start_date && validation.errors.duration_poa_start_date ?  ( 
                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                            {validation.errors.duration_poa_start_date}
                                        </FormFeedback> 
                                    ) : false }
                                </FormGroup>
                            </Col>
                            <Col md={5}>
                                <FormGroup>
                                    <Label className="label-title">วันที่สิ้นสุด (End Date)<span className="msg-require">*</span></Label>
                                    <Input id="txtDurationPoaEndDate"
                                        name="duration_poa_end_date"
                                        type="date"
                                        className="form-control"
                                        value={validation.values.duration_poa_end_date || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.duration_poa_end_date && validation.errors.duration_poa_end_date ? true : false }
                                        disabled={formIsDisabled || durationPoaType !== "2"}
                                    />
                                    { validation.touched.duration_poa_end_date && validation.errors.duration_poa_end_date ?  ( 
                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                            {validation.errors.duration_poa_end_date}
                                        </FormFeedback> 
                                    ) : false }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">ระบุเหตุผลความจำเป็น (please also provide the reason for this necessity)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prPurposePoaReason"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prPurposePoaReason" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i>
                                                ถ้าวันที่เริ่มต้นเป็นวันที่ย้อนหลัง โปรดระบุเหตุผลความจำเป็น
                                                <br />
                                                If the start date is backdated, please specify the reason for necessity.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtPurposePoaReason"
                                        name="duration_poa_reason"
                                        placeholder="กรอก"
                                        type="textarea"
                                        rows="5"
                                        className="from-control"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.duration_poa_reason || ""}
                                        invalid={ validation.touched.duration_poa_reason && validation.errors.duration_poa_reason ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                    { validation.touched.duration_poa_reason && validation.errors.duration_poa_reason ? ( 
                                        <FormFeedback type="invalid" style={{display: "block"}}>
                                            {validation.errors.duration_poa_reason}
                                        </FormFeedback> 
                                    ) : false }
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-12">
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">พยาน (Witness)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prWitness"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prWitness" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดระบุคำนำหน้า ชื่อ และนามสกุลของพยาน จำนวน 1 ท่าน
                                                <br />
                                                Please specify the title, first name, and last name of one witness.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtWitness"
                                        name="witness"
                                        type="text"
                                        placeholder="กรอก"
                                        className="txt-placeholder"
                                        value={validation.values.witness || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.witness && validation.errors.witness ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                    {validation.touched.witness && validation.errors.witness ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.witness}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">
                                        แบบฟอร์มและเอกสารอื่น ๆ ที่ต้องกรอกและใช้ยื่นเรื่องพร้อมกับหนังสือมอบอำนาจ 
                                        <br/>
                                        (Forms and other documents that must be completed along with the POA)<span className="msg-require">*</span>
                                    </Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prFormOtherPoa"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prFormOtherPoa" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดกรอกแบบฟอร์มและเอกสารอื่นๆ ที่ต้องใช้ยื่นเรื่องพร้อมกับหนังสือมอบอำนาจให้เรียบร้อย และ หากต้องใช้เอกสารอื่นใดที่เป็นเอกสารของบริษัท เช่น ใบเสร็จรับเงิน แบบแปลน แผนที่ รูปภาพ/ภาพถ่าย เป็นต้น ขอให้ user ระบุว่าจะจัดเตรียม เอกสารส่วนใดเองบ้าง
                                                <br />
                                                Please fill out the form and other documents which required the requested Power of Attorney. If there are corporate documents required for the same matter, ex. receipt, floor plan, map, picture, please specify the documents that you will prepare by yourself.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtFormOtherPoa"
                                        name="form_other_poa"
                                        type="textarea"
                                        rows="5"
                                        placeholder="กรอก"
                                        className="txt-placeholder"
                                        value={validation.values.form_other_poa || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.form_other_poa && validation.errors.form_other_poa ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                    {validation.touched.form_other_poa && validation.errors.form_other_poa ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.form_other_poa}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-13">
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title mb-3">
                                        เอกสารแนบ (Attachment)
                                    </Label>
                                    <SingleUploadfile inputID="formOtherPoaDoc" folder={dataFormRequest.request_no} dataFile={fileFormOtherPoaDoc} setDataFile={OnSetFileFormOtherPoaDoc} isDisable={formIsDisabled} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">
                                        เอกสารประกอบอื่น ๆ (นอกเหนือจากชุดหนังสือมอบอำนาจ) ที่ขอจากฝ่ายกฎหมาย<br />
                                        (Other supporting documents required from Legal Team)
                                    </Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prOtherSupportDoc"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prOtherSupportDoc" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i>
                                                โปรดระบุว่า ต้องใช้เอกสารประกอบอื่นใดที่ขอจากฝ่ายกฎหมายอีกบ้าง เช่น ชุดหนังสือยินยอมให้ใช้สถานที่ ,โฉนดที่ดิน (ที่ต้องจัดพิมพ์เท่าขนาดจริงและ/หรือจัดพิมพ์ทั้งด้านหน้าและด้านหลัง) ,ใบทะเบียนภาษีมูลค่าเพิ่ม (ภ.พ.20) สำนักงานใหญ่ และ/หรือสาขาที่เท่าใด , ใบอนุญาตต่าง ๆ
                                                <br />
                                                Please specify any additional supporting documents required from the Legal Team, such as:- Set of letter of consent for using premises,
                                                <br />
                                                - Land title deeds which must be printed to actual size and/or include both front and back,
                                                <br />
                                                - VAT registration certificate (P.T. 20) for headquarters and/or branches,
                                                <br />
                                                - Licenses.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtOtherSupportDoc"
                                        name="other_support_doc"
                                        type="textarea"
                                        rows="5"
                                        placeholder="กรอก"
                                        className="txt-placeholder"
                                        value={validation.values.other_support_doc || ""}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.other_support_doc && validation.errors.other_support_doc ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>                    
                        <Row>
                            <Col md={12}>
                                <div className="line-border"></div>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-2-1">
                        <Row>
                            <Col md={12} className="mb-3">
                                <span className="span-title">
                                    เอกสารประกอบหนังสือมอบอำนาจ (Supporting documents to the POA) 
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10} className="mb-3">
                                <p className="span-subheader-title pdleft-15 mb-0">
                                    หนังสือรับรองบริษัท
                                </p>
                                <p className="span-subheader-title-desc pdleft-15 mb-0">
                                    Company Affidavit
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title-nopd mb-3">
                                        ฝ่ายกฎหมายจะให้หนังสือรับรองบริษัทอายุไม่เกิน 6 เดือน นับแต่วันที่ทำหนังสือมอบอำนาจ หาก user ประสงค์ให้หนังสือรับรอง
                                        <br/>
                                        บริษัท มีอายุน้อยกว่า 6 เดือน โปรดระบุจำนวนเดือนหรือจำนวนวันที่ต้องการ และหากต้องการหนังสือรับรองบริษัทมากกว่า
                                        <br/>
                                        1 ฉบับ โปรดระบุเหตุผลความจำเป็นที่ขอเพิ่มด้วย 
                                        <br/>
                                        Legal Team will provide a company certification with a validity of no more than 6 months from the date
                                        <br/>
                                        of the power of attorney. If you wish for the certification to be less than 6 months old, please specify the 
                                        <br/>
                                        desired number of months or days. Additionally, if you require more than one copy of the company 
                                        <br/>
                                        certification, please state the reason for requesting the additional copies.
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-2-2">
                        <Row>
                            <Col md={10}>
                                <div className="form-check ms-5">
                                    <Input id="cbOneCopy"
                                        name="company_affidavit_type"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={companyAffidavitType === "1"}
                                        onChange={() => {
                                            setCompanyAffidavitType("1");
                                            validation.handleChange('company_affidavit_type')("1");
                                            validationDraft.handleChange('company_affidavit_type')("1");
                                            setIsSaveEnabled(true);
                                        }}
                                        disabled={formIsDisabled}
                                    />
                                    <Label className="form-check-label-2row" for="cbOneCopy">
                                        หนังสือรับรองน้อยกว่า 6 เดือน
                                        <br/>
                                        <span className="form-check-label-2row-detail">
                                            Acknowledge and use a company affidavit with a validity of no more than 6 months, with 1 copy
                                        </span>
                                    </Label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup className="ms-5">
                                    <Label className="label-title">ระบุอายุของหนังสือรับรองที่ต้องการ<span className="msg-require">*</span></Label>
                                    <Input id="txtCompanyAffidavitAge"
                                        name="company_affidavit_age"
                                        type="text"
                                        placeholder="xxx เดือน"
                                        className="txt-placeholder"
                                        value={validation.values.company_affidavit_age || ""}
                                        onChange={(e) => {
                                            ValidateNumber(e);
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.company_affidavit_age && validation.errors.company_affidavit_age ? true : false }
                                        disabled={formIsDisabled || companyAffidavitType !== "1"}
                                    />
                                    {validation.touched.company_affidavit_age && validation.errors.company_affidavit_age ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.company_affidavit_age}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <div className="form-check ms-5">
                                    <Input id="cbMoreCopy"
                                        name="company_affidavit_type"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={companyAffidavitType === "2"}
                                        onChange={() => {
                                            setCompanyAffidavitType("2");
                                            validation.handleChange('company_affidavit_type')("2");
                                            validationDraft.handleChange('company_affidavit_type')("2");
                                            setIsSaveEnabled(true);
                                        }}
                                        disabled={formIsDisabled}
                                    />
                                    <Label className="form-check-label-2row" for="cbMoreCopy">
                                        หนังสือรับรองมากกว่า 1 ฉบับ
                                        <br/>
                                        <span className="form-check-label-2row-detail">
                                            Request a company affidavit that is less than 6 months old or more than 1 copy
                                        </span>
                                    </Label>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-2-3">
                        <Row>
                            <Col md={10}>
                                <FormGroup className="ms-5">
                                    <Label className="label-title">โปรดระบุจำนวนและ เหตุผลหากต้องการมากกว่า 1 ฉบับ (Please specify if needed more than 1 copy)<span className="msg-require">*</span></Label>
                                    <Input id="txtCompanyAffidavitReason"
                                        name="company_affidavit_reason"
                                        placeholder="ต้องการนำไปใช้ดำเนินการเรื่อง"
                                        type="textarea"
                                        rows="3"
                                        className="from-control"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.company_affidavit_reason || ""}
                                        invalid={ validation.touched.company_affidavit_reason && validation.errors.company_affidavit_reason ? true : false }
                                        disabled={formIsDisabled || companyAffidavitType !== "2"}
                                    />
                                    { validation.touched.company_affidavit_reason && validation.errors.company_affidavit_reason ? ( 
                                        <FormFeedback type="invalid" style={{display: "block"}}>
                                            {validation.errors.company_affidavit_reason}
                                        </FormFeedback> 
                                    ) : false }
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-3-1">
                        <Row>
                            <Col md={10} className="mb-3 mt-2">
                                <label className="span-subheader-title pdleft-15">
                                    บัตรประชาชนและ/หรือทะเบียนบ้านผู้มอบอำนาจ
                                </label>
                                <i className="mdi mdi-help-circle icon-hint-end" id="prFormOtherPoa"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prFormOtherPoa" >
                                        <PopoverBody className="msg-show-hint">
                                            <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                            กรณีเป็นคนต่างด้าว จะเป็นหนังสือเดินทางแทนบัตรประชาชน ไม่มีทะเบียนบ้าน และหากต้องการใบอนุญาตทำงานของคนต่างด้าว โปรดติดต่อสอบถามฝ่ายกฎหมายก่อน
                                            <br />
                                            In the case of a foreign person, the passport will be used instead of the ID card, as there is no house registration. If a work permit for a foreign person is also required, please consult the Legal Team beforehand.
                                        </PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <label className="span-subheader-title-desc pdleft-15">
                                    ID Card and/or House Registration of the Grantor
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title-nopd mb-3">
                                        โปรดระบุว่าใช้เพียงบัตรประชาชนเท่านั้นหรือ ต้องใช้ทั้งบัตรประชาชนและทะเบียนบ้าน หาก user ต้องการเอกสารผู้มอบอำนาจ
                                        <br/>
                                        มากกว่าท่านละ 1 ฉบับ โปรดระบุเหตุผลความจำเป็นที่ขอเพิ่มด้วย
                                        <br/>
                                        Please specify whether only the ID card is required, or if both the  ID card and house registration are
                                        <br/>
                                        needed. If the user needs more than one copy of the documents for the grantor, please state the 
                                        <br/>
                                        reason for the additional copies.
                                    </Label>
                                    <div className="form-check ms-5">
                                        <Input id="cbIDcardAndHouseRegis"
                                            name="req_idcard_houseregis_type"
                                            className="form-check-input" 
                                            type="radio"
                                            checked={reqIdcardHouseregisType === "1"}
                                            onChange={() => {
                                                setReqIdcardHouseregisType("1");
                                                validation.handleChange('req_idcard_houseregis_type')("1");
                                                validationDraft.handleChange('req_idcard_houseregis_type')("1");
                                                setIsSaveEnabled(true);
                                            }}
                                            disabled={formIsDisabled}
                                        />
                                        <Label className="form-check-label-2row" for="cbIDcardAndHouseRegis">
                                            บัตรประชาชน
                                            <br/>
                                            <span className="form-check-label-2row-detail">
                                                ID Card
                                            </span>
                                        </Label>
                                    </div>
                                    <div className="form-check ms-5 mt-3">
                                        <Input id="cbIDcardOrHouseRegis"
                                            name="req_idcard_houseregis_type"
                                            className="form-check-input" 
                                            type="radio"
                                            checked={reqIdcardHouseregisType === "2"}
                                            onChange={() => {
                                                setReqIdcardHouseregisType("2");
                                                validation.handleChange('req_idcard_houseregis_type')("2");
                                                validationDraft.handleChange('req_idcard_houseregis_type')("2");
                                                setIsSaveEnabled(true);
                                            }}
                                            disabled={formIsDisabled}
                                        />
                                        <Label className="form-check-label-2row" for="cbIDcardOrHouseRegis">
                                            บัตรประชาชนและทะเบียนบ้าน
                                            <br/>
                                            <span className="form-check-label-2row-detail">
                                                ID card and house registration
                                            </span>
                                        </Label>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-3-2">
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label className="label-title">ระบุจำนวน (Copies)<span className="msg-require">*</span></Label>
                                    <Input id="txt"
                                        name="req_idcard_houseregis_amount"
                                        type="text"
                                        placeholder="กรอก"
                                        className="txt-placeholder"
                                        value={validation.values.req_idcard_houseregis_amount || ""}
                                        onChange={(e) => {
                                            ValidateNumber(e);
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={ validation.touched.req_idcard_houseregis_amount && validation.errors.req_idcard_houseregis_amount ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                    {validation.touched.req_idcard_houseregis_amount && validation.errors.req_idcard_houseregis_amount ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.req_idcard_houseregis_amount}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">โปรดระบุเหตุผลหากต้องการมากกว่า 1 ฉบับ (Please specify if needed more than 1 copy)<span className="msg-require">*</span></Label>
                                    <Input id="txtReqIdCardHouseregisReason"
                                        name="req_idcard_houseregis_reason"
                                        placeholder="ต้องการนำไปใช้ดำเนินการเรื่อง"
                                        type="textarea"
                                        rows="5"
                                        className="from-control"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.req_idcard_houseregis_reason || ""}
                                        invalid={ validation.touched.req_idcard_houseregis_reason && validation.errors.req_idcard_houseregis_reason ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                    { validation.touched.req_idcard_houseregis_reason && validation.errors.req_idcard_houseregis_reason ? ( 
                                        <FormFeedback type="invalid" style={{display: "block"}}>
                                            {validation.errors.req_idcard_houseregis_reason}
                                        </FormFeedback> 
                                    ) : false }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <div className="line-border"></div>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-4-1">
                        <Row>
                            <Col md={12} className="mb-3">
                                <span className="span-title">
                                    อื่นๆ (Others)
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">ข้อมูลอื่น ๆ (Other information)</Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prOtherInfo"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="top" target="prOtherInfo">
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i>
                                                โปรดระบุในข้อนี้ หาก user มีเรื่องอื่นใดเพิ่มเติมนอกจากข้อที่ระบุไว้แล้ว
                                                <br />
                                                Please specify if there are any additional matters or requests beyond those mentioned.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtOtherInfo"
                                        name="other_info"
                                        placeholder="หากมีเรื่องอื่นใดเพิ่มเติม"
                                        type="text"
                                        className="from-control"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.other_info || ""}
                                        invalid={ validation.touched.other_info && validation.errors.other_info ? true : false }
                                        disabled={formIsDisabled}
                                    />
                                    { validation.touched.other_info && validation.errors.other_info ? ( 
                                        <FormFeedback type="invalid" style={{display: "block"}}>
                                            {validation.errors.other_info}
                                        </FormFeedback>
                                    ) : false }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">ระบุชื่อนักกฎหมายที่เคยตรวจเอกสารนี้ (Legal team who has handled this work (if any))</Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prRequireHandledBy"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="top" target="prRequireHandledBy">
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i>
                                                คำขอนี้จะถูกส่งถึง E-mail ของบุคคลที่ถูกระบุชื่อไว้ด้วย (ขั้นตอนนี้ไม่ใช่การกำหนดเลือกคนทำงาน ฝ่ายกฎหมายขอสงวนสิทธิ์ในการกำหนดคนทำงานนี้ต่อไป)
                                                <br />
                                                This request will be sent to the e-mail address of the named person. (This step is not to select workers. The Legal Department reserves the right to solely decide and assign people to do this work.)
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtRequireHandledBy"
                                        name="require_handled_by"
                                        placeholder="กรอกชื่อ"
                                        type="text"
                                        className="from-control"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.require_handled_by || ""}
                                        invalid={ validation.touched.require_handled_by && validation.errors.require_handled_by ? true : false }
                                        disabled={dataFormRequest.id_workflow_status > 4 ? true : formIsDisabled}
                                    />
                                    { validation.touched.require_handled_by && validation.errors.require_handled_by ? ( 
                                        <FormFeedback type="invalid" style={{display: "block"}}>
                                            {validation.errors.require_handled_by}
                                        </FormFeedback>
                                    ) : false }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <div className="line-border"></div>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-5-1">
                        <Row>
                            <Col md={12} className="mb-2">
                                <span className="span-title">
                                    User Approval Process
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">
                                        ผู้อนุมัติแบบคำขอ (User Approver)<span className="msg-require">*</span>
                                    </Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prApproval"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prApproval" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i>
                                                โปรดระบุอีเมลผู้อนุมัติคำขอ โดยคำขอทุกฉบับต้องได้รับการอนุมัติจากผู้มีตำแหน่ง Director ขึ้นไปในฝ่ายผู้ขอ
                                                <br />
                                                (Please specify the approver's e-mail. Kindly note that all requests must be approved by director or higher level in your function.)
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtApproveRequestBy"
                                        name="approve_request_by"
                                        type="text"
                                        className="txt-placeholder"
                                        placeholder="กรอกชื่อผู้อนุมัติ"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.approve_request_by || ""}
                                        invalid={validation.touched.approve_request_by && validation.errors.approve_request_by ? true : false}
                                        disabled={formIsDisabled || (dataFormRequest.request_no !== "draft" && dataUser.email === dataFormRequest.approve_request_by) || (dataFormRequest.id_workflow_status > 4) ? true : false}
                                    />
                                    {validation.touched.approve_request_by && validation.errors.approve_request_by ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.approve_request_by}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                        { checkShowInputUserCoordinator ? (
                            <Row id="section-page-5-2">
                                <Col md={10}>
                                    <FormGroup>
                                        <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightCoodinator"></i>
                                        <div className="hstack flex-wrap gap-2">
                                            <UncontrolledPopover placement="right" target="PopoverRightCoodinator">
                                                <PopoverBody className="msg-show-hint">
                                                    <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                    โปรดระบุอีเมลของผู้ประสานงานสำหรับคำขอนี้โดยจะต้องเป็นผู้ที่มีรายชื่อเป็นผู้ประสานงานตามที่บริษัทกำหนดและได้แจ้งฝ่ายกฎหมาย BTSG ไว้แล้ว <br/>Please specify the email address of the coordinator for this request. The specified person must be listed as a coordinator as designated by the company and has been informed to BTSG legal team.
                                                </PopoverBody>
                                            </UncontrolledPopover>
                                        </div>
                                        <Label className="label-title">ชื่อผู้ประสานงาน (Name of User Coordinator)<span className="msg-require">*</span></Label>
                                        <Input id="txtCreateRequestBy"
                                            name="create_request_by"
                                            type="text"
                                            autoComplete="off"
                                            className="txt-placeholder"
                                            placeholder="กรอกอีเมลผู้ประสานงาน"
                                            onChange={(e) => {
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.create_request_by || ""}
                                            invalid={validation.touched.create_request_by && validation.errors.create_request_by ? true : false}
                                            disabled={formIsDisabled || (dataFormRequest.request_no !== "draft" && dataUser.email === dataFormRequest.create_request_by) || (dataFormRequest.id_workflow_status > 4) ? true : false}
                                        />
                                        {validation.touched.create_request_by && validation.errors.create_request_by ? (
                                            <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                                {validation.errors.create_request_by}
                                            </FormFeedback>
                                        ) : false}
                                    </FormGroup>
                                </Col>
                            </Row>
                        ) : null }
                        { showCommentApprover === true || dataFormPoa?.approver_comment !== "" ? (
                            <Row id="section-page-5-3">
                                <Col md={12}>
                                    <div className="line-border"></div>
                                </Col>
                                <Col md={10}>
                                    <div className="page-content-approver">
                                        <div className="approver-header-content">
                                            {dataUser.email === dataFormRequest.approve_request_by ? "ระบุความเห็นเพื่อส่งไปยังผู้ร้องขอ (Please specify comments to send to the requester.)" : "คุณมีความเห็นจากผู้อนุมัติ (You have a comments from the approver)"}
                                        </div>
                                        <FormGroup>
                                            <Col md={10} className="approver-col">
                                                <Label className="label-title-approver-comment">ความเห็นของผู้อนุมัติ (Approver's Comment)</Label>
                                                <Input
                                                    type="text"
                                                    id="txtApproveComment"
                                                    name="approver_comment"
                                                    autoComplete="off"
                                                    className="txt-approver-comment"
                                                    placeholder="ความเห็นเพิ่มเติมของผู้อนุมัติ"
                                                    onChange={(e) => {
                                                        validation.handleChange(e);
                                                        validationDraft.handleChange(e);
                                                        validationReturn.handleChange(e);
                                                        setIsSaveEnabled(true);
                                                    }}
                                                    onBlur={validationReturn.handleBlur}
                                                    value={validation.values.approver_comment || ""}
                                                    invalid={validationReturn.touched.approver_comment && validationReturn.errors.approver_comment ? true : false}
                                                    disabled={(dataUser.email === dataFormRequest.request_by) || (dataUser.email === dataFormRequest.approve_request_by && dataFormRequest.id_workflow_status === 4) ? true : false}
                                                />
                                                {validationReturn.touched.approver_comment && validationReturn.errors.approver_comment ? (
                                                    <FormFeedback type="invalid" className="alert-validation-approver-comment">
                                                        {validationReturn.errors.approver_comment}
                                                    </FormFeedback>
                                                ) : false}
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="line-border"></div>
                                </Col>
                            </Row>
                        ) : null }
                    <div id="section-page-5-4">
                        <Row>
                            <Col md={10}>
                                <Alert className="border-0 border-0 remark-content">
                                    <i className="mdi mdi-alert icon-remark-color"></i><strong className="remark-color"> หมายเหตุ (Remark) </strong><br/>
                                    <span className="span-remark">"User รับทราบว่าแบบฟอร์มนี้เป็นความลับและมีวัตถุประสงค์เพื่อใช้ภายในบริษัทในเครือ BTS Group เท่านั้น หากพนักงานเปิดเผยข้อมูลแบบฟอร์มให้แก่บุคคลภายนอก ถือว่าประพฤติผิดวินัยอย่างร้ายแรง"</span><br/>
                                    <span className="span-remark">"Users are fully aware that this request form is strictly private and confidential for internal use within BTS Group's affiliates only. Any employee disclosing this request form to the third party is considered a serious misconduct."</span>
                                </Alert>
                            </Col>
                        </Row>
                    </div>
                    { // Check if status is 0 or greater
                        ( (dataFormRequest.id_workflow_status >= 0 && dataFormRequest.id_workflow_status <= 4) || dataFormPoa.id === 0 )
                        ? (
                            <Row>
                                <div className="page-footer">
                                    <div className="layout-width-footer">
                                        <div className="navbar-footer">
                                            <div className="d-flex align-items-center">
                                                <Link to={GetUrlBack()} className="logo">
                                                    <Button color="outline secondary" type="button" >
                                                        Back
                                                    </Button>
                                                </Link>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                { ( dataFormRequest.request_no === "draft" ) ? (
                                                    <Button color="outline secondary" type="button" onClick={() => onCancelRequest(dataFormRequest)} >
                                                        Delete
                                                    </Button>
                                                ) : null}
                                                {/* case if requestor && approver ถ้าคนเปิด request และ คนอนุมัติเป็นคนเดียวกันจะปิด ปุ่ม return  */}
                                                {checkUserIsApproverShowReturnBtn === true && checkUserCreateTicketAndApproveIsSame === true ? (
                                                    <Button className="btn-return-style" color="outline secondary" type="button" onClick={() => onClickCheckReturn()} >
                                                        Return
                                                    </Button>
                                                ) : null}
                                                {changeButtonIsStateRequestorOrApprover ?(
                                                    <>
                                                        <Button 
                                                            className="float-end btn-save-style"  
                                                            color={isSaveEnabled ? "primary" : "secondary"} 
                                                            outline 
                                                            type="button" 
                                                            disabled={!isSaveEnabled}
                                                            onClick={() => onClickCheckSaveDraft()}
                                                        >
                                                            Save
                                                        </Button>
                                                        <Button 
                                                            className="float-end btn-submit-style" 
                                                            color="primary" 
                                                            type="button"
                                                            onClick={() => { onClickCheckSubmit()}}
                                                        >
                                                            {dataUser.email === dataFormRequest.approve_request_by ? "Approve" : "Submit"}
                                                        </Button>
                                                    </>
                                                ):null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        ): (
                            <div id="footer-modal">
                                <hr className="line-footer"></hr>
                                <Col md={12}>
                                    <Button 
                                        className="float-end btn-submit-style" 
                                        color="primary" 
                                        type="button"
                                        onClick={() => validation.submitForm()}
                                    >
                                        Update
                                    </Button>
                                    <Button 
                                        className="float-end btn-cancel" 
                                        color="outline secondary" 
                                        type="button" 
                                        onClick={() => onCancelRequest(false)}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </div>
                        )
                    }
                </Form>
            </div>
        </React.Fragment>       
    );
};

export default RequestFormPoa;